import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const EaseOfUseCampingEquipment = ({ onEaseOfUseCampingEquipmentSelected }) => {
  const [
    selectedEaseOfUseCampingEquipment,
    setSelectedEaseOfUseCampingEquipment,
  ] = useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.easeofusecampingequipment) {
        const easeOfUseCampingEquipmentObject =
          firstResult.easeofusecampingequipment;
        if (easeOfUseCampingEquipmentObject.trim() !== "") {
          setVariations(easeOfUseCampingEquipmentObject.split(","));
        }
      }
    } catch (error) {
      // Handle error here
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handleEaseOfUseCampingEquipmentClick = (easeofusecampingequipment) => {
    setSelectedEaseOfUseCampingEquipment(easeofusecampingequipment);
    onEaseOfUseCampingEquipmentSelected(easeofusecampingequipment);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Ease Of Use Camping Equipment:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedEaseOfUseCampingEquipment === variation ? "selected" : ""}`}
            onClick={() => handleEaseOfUseCampingEquipmentClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default EaseOfUseCampingEquipment;
